import { render, staticRenderFns } from "./SwRegister.vue?vue&type=template&id=cdca050e"
import script from "./SwRegister.vue?vue&type=script&lang=js"
export * from "./SwRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports